/* eslint-disable react-hooks/exhaustive-deps */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { withCarrierPermission } from "../../utils/HOC/withCarrierPermission";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect, useMemo } from "react";
import { usePartners } from "../../store/usePartners";
import { PartnersTable } from "./PartnersTable";

/**
 * Parcel carriers. They are partners like any other in the database, but they
 * stay out of the app's partner list unless an admin shows one from its edit
 * page: the app offers them when a customer registers a parcel, and a parcel
 * challenge names them as the carriers whose handoffs count. Listing them with
 * ordinary partners marked "not visible in app" read as a misconfiguration,
 * which is why they have their own page.
 */
function CarrierPartnersScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { allPartners, getAllPartners } = usePartners();

  /** Effects */
  useEffect(() => {
    getAllPartners(1, 1000);
  }, []);

  const carrierCount = useMemo(
    () => (allPartners ?? []).filter((partner) => partner?.isCourier).length,
    [allPartners]
  );

  /** Callbacks */
  const addCarrier = () => navigate(`/add-partner?carrier=1`);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-5 sm:mb-11">
          Carrier partners
        </h1>
        <PrimaryButton label="Add new" onClick={addCarrier} className="h-10" />
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        <p className="mb-4 font-satoshi text-sm text-gray-600">
          Carriers do not appear in the app's partner list unless an admin
          switches "Show this carrier in mobile app" on in its edit page. They
          are offered when a customer registers a parcel, and a parcel
          challenge picks its carriers from here.
        </p>
        {!carrierCount ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no carrier partner created yet.
          </p>
        ) : (
          <PartnersTable carriersOnly />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(withCarrierPermission(CarrierPartnersScreen));
